<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAnalytics } from '@composables/use-analytics'

const route = useRoute()
const analyticsService = useAnalytics()

const isSuccessful = computed(() => route.query.state === 'success')

onMounted(() => {
    analyticsService.donationUpsellCompleted({ isSuccessful: isSuccessful.value })
})
</script>

<template>
    <div>
        <BaseSection
            v-if="isSuccessful"
            padded
        >
            <h1 class="main-header">Thank you for donating to <strong>FRISKY</strong></h1>
            <h6 class="description">Your contribution will help us stay on the air!</h6>
            <div>
                <router-link :to="{ name: 'home' }">
                    <BaseButton
                        button-type="secondary"
                        @click="() => {}"
                    > BROWSE FRISKY </BaseButton>
                </router-link>
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.main-header {
    margin-bottom: 100px;
    font-weight: 600;
    line-height: 1.25;
}

.description {
    margin-bottom: 50px;
    font-weight: 300;
    line-height: 1.5;

    @extend %secondary;
}

@include desktop {
    .main-header {
        margin-bottom: 150px;
        font-size: $s-xxxl;
    }

    .description {
        margin-bottom: 100px;
    }
}
</style>
